/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Primary_School_Teaching26Inputs */

const en__field_enum_study_primary_school_teaching26 = /** @type {(inputs: _Field_Enum_Study_Primary_School_Teaching26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary School Teaching`)
};

const de__field_enum_study_primary_school_teaching26 = /** @type {(inputs: _Field_Enum_Study_Primary_School_Teaching26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt für Grundschulen`)
};

/**
* | output |
* | --- |
* | "Primary School Teaching" |
*
* @param {_Field_Enum_Study_Primary_School_Teaching26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_primary_school_teaching26 = /** @type {((inputs?: _Field_Enum_Study_Primary_School_Teaching26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Primary_School_Teaching26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_primary_school_teaching26(inputs)
	return de__field_enum_study_primary_school_teaching26(inputs)
});
export { _field_enum_study_primary_school_teaching26 as "_field_enum_STUDY_PRIMARY_SCHOOL_TEACHING" }